const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<div class="c-button-swap js-button-swap`);
                if ((context.has(`class`) ? context.get(`class`) : null)) {
                    this.echo(` `);
                    this.echo(this.env.getFilter('escape').traceableCallable(5, this.source)(...[this.env, (context.has(`class`) ? context.get(`class`) : null), `html`, null, true]));
                }
                this.echo(`">
  <div class="c-button-swap__subscribe js-button-swap__initial-button-wrapper">
    <span tabindex="-1" role="status" class="u-hidden-visually js-button-swap__message">
      `);
                this.echo(this.env.getFilter('escape').traceableCallable(8, this.source)(...[this.env, (((context.has(`initial_label`))) ? (this.env.getFilter('default').traceableCallable(8, this.source)(...[(context.has(`initial_label`) ? context.get(`initial_label`) : null), `Currently unsubscribed from notifications`])) : (`Currently unsubscribed from notifications`)), `html`, null, true]));
                this.echo(`
    </span>

    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/button/button.twig`, new Map([[`class`, this.env.getFilter('join').traceableCallable(12, this.source)(...[new Map([[0, `js-button-swap__button`], [1, (context.has(`button_class`) ? context.get(`button_class`) : null)]]), ` `])], [`content_start_icon`, (((context.has(`content_start_icon`))) ? (this.env.getFilter('default').traceableCallable(13, this.source)(...[(context.has(`content_start_icon`) ? context.get(`content_start_icon`) : null), `bell`])) : (`bell`))], [`label`, (((context.has(`initial_visual_label`))) ? (this.env.getFilter('default').traceableCallable(14, this.source)(...[(context.has(`initial_visual_label`) ? context.get(`initial_visual_label`) : null), `Get notifications`])) : (`Get notifications`))]]), false, false, 11));
                this.echo(`  </div>
  <div class="c-button-swap__unsubscribe js-button-swap__swapped-button-wrapper" hidden>
    <span tabindex="-1" role="status" class="u-hidden-visually js-button-swap__message">
      `);
                this.echo(this.env.getFilter('escape').traceableCallable(19, this.source)(...[this.env, (((context.has(`swapped_label`))) ? (this.env.getFilter('default').traceableCallable(19, this.source)(...[(context.has(`swapped_label`) ? context.get(`swapped_label`) : null), `Currently subscribed to notifications`])) : (`Currently subscribed to notifications`)), `html`, null, true]));
                this.echo(`
    </span>

    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/button/button.twig`, new Map([[`class`, this.env.getFilter('join').traceableCallable(28, this.source)(...[new Map([[0, `c-button--secondary`], [1, `is-slashed`], [2, `js-button-swap__button`], [3, (context.has(`button_class`) ? context.get(`button_class`) : null)]]), ` `])], [`content_start_icon`, (((context.has(`content_start_icon`))) ? (this.env.getFilter('default').traceableCallable(29, this.source)(...[(context.has(`content_start_icon`) ? context.get(`content_start_icon`) : null), `bell`])) : (`bell`))], [`label`, (((context.has(`swapped_visual_label`))) ? (this.env.getFilter('default').traceableCallable(30, this.source)(...[(context.has(`swapped_visual_label`) ? context.get(`swapped_visual_label`) : null), `Turn off notifications`])) : (`Turn off notifications`))]]), false, false, 22));
                this.echo(`  </div>
</div>
`);
            }

            getTemplateName() {
                return `25e5eb51ed27f27fa9a15a72f47719a3f0d2964ba02dbb150d7d26855916e747`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `25e5eb51ed27f27fa9a15a72f47719a3f0d2964ba02dbb150d7d26855916e747`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '25e5eb51ed27f27fa9a15a72f47719a3f0d2964ba02dbb150d7d26855916e747');

let template = env.loadTemplate('25e5eb51ed27f27fa9a15a72f47719a3f0d2964ba02dbb150d7d26855916e747');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/button-swap/button-swap.twig", args: context }
     );
     return rendered;;
};